var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',{attrs:{"type":"info","text":"","icon":false}},[_c('div',{staticClass:"text-h6 mt-n1"},[_vm._v(" Uploaded submissions will be listed here. ")])])}
var staticRenderFns = []

export { render, staticRenderFns }